import React from 'react';
import classes from './CityBrowseBannerImage.module.scss';
import { CityImageProps } from './interface';

// Breakpoints for different header background sizes
const HEADER_BACKGROUND_BREAKPOINTS: { [key: string]: any } = {
    tablet: 660,
    desktop: 1608,
    twok: 1920,
};

const CityImage = ({
    cityImage,
    citySmallImage,
    currentPlace,
    imgClassNames,
}: CityImageProps) => {
    let component = null;

    if (cityImage) {
        component = (
            <>
                {/* Responsive image sources */}
                <source
                    media={`(max-width: ${HEADER_BACKGROUND_BREAKPOINTS['tablet']}px)`}
                    srcSet={citySmallImage}
                />
                <img
                    //HTML Img Definition doesnt support fetchpriority but it
                    //is supported in chrome and edge with broader support coming
                    //https://caniuse.com/mdn-html_elements_img_fetchpriority
                    //eslint-disable-next-line
                    //@ts-ignore
                    fetchpriority="high"
                    src={cityImage}
                    alt={currentPlace}
                    title={'View events in ' + currentPlace}
                    className={imgClassNames}
                    loading="eager"
                    height={791}
                    width={488}
                />
                {/* Overlay for background gradient */}
                <div className={classes.overlay}></div>
            </>
        );
    }

    return component;
};

export class CityBrowseBannerImage extends React.PureComponent<CityImageProps> {
    render() {
        const { currentPlace, cityImage } = this.props;

        return (
            <div className={classes.cityBrowseHeaderImageContainer}>
                <CityImage
                    cityImage={cityImage}
                    currentPlace={currentPlace}
                    imgClassNames={`full-width-img ${classes.cityBrowseHeaderImage}`}
                />
            </div>
        );
    }
}
